export default __webpack_public_path__ + "static/media/img_6_thumb.e810940a.jpg";